<template>
  <div>
    <contact-information-add
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.id)"
      :is-add="isAdd"
      :action="action"
      :edit-object-name="editObjectName"
      :isExternal="isExternal"
      @confirm="editConfirm"
      @cancel="editCancel"
    />
    <div class="level no-margin">
      <div class="level-left"></div>
      <div class="level-right" v-if="disableActionItem()">
        <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li>
              <a @click.prevent="addModal" data-cy="new-contact">New contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <circul8-table
      :records="data"
      :fields="columns"
      :routeNext="false"
      :usePropRecords="true"
      @clickcheck="checkCheckBox"
      @clickEdit="editModal"
      @clickView="viewModal"
      @clickDelete="deleteModal"
      :showRemoveButton="showDelete"
      :showEditButton="showEdit"
      :isCheckable="false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Permission } from "../../services/Permissions";
import ContactInformationAdd from "@/components/Customers/ContactInformationAdd";
import ContactInformationService from "@/services/ContactInformationService";
import Circul8Table from "../../components/Circul8Table.vue";
import utilityMixin from "@/mixins/UtilityMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
// @group Customers
export default {
  name: "ContactInformation",
  mixins: [utilityMixin, UserPermissionMixin],
  components: { ContactInformationAdd, Circul8Table },
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    contactAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExternal: false,
      data: [],
      isModalActive: false,
      isAdd: false,
      action: null,
      editObject: {},
      isLoading: false,
      paginated: false,
      perPage: 10,
      checkedRows: [],
      columns: [
        {
          field: "first_name",
          label: "First Name",
          sticky: true
        },
        {
          field: "family_name",
          label: "Family Name"
        },
        {
          field: "position",
          label: "Position"
        },
        {
          field: "contact_type",
          label: "Contact Type"
        },
        {
          field: "email",
          label: "Email"
        },
        //{ field: "email_types", label: "Email Types" },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ],
      ContactInformationService: new ContactInformationService()
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "switchCustomerView"
    ]),

    editObjectName() {
      return this.editObject || this.getClearFormObject();
    }
  },
  mounted() {
    this.fetchContactInformationData();
    if (!this.userExternalCheck() && !this.switchCustomerView) {
      this.isExternal = false;
      const popped = this.columns.pop();
      this.columns.push({ field: "email_types", label: "Email Types" });
      this.columns.push(popped);
    } else {
      this.isExternal = true;
    }
  },
  methods: {
    checkCheckBox(d) {
      this.checkedRows = d;
    },

    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    getClearFormObject() {
      return {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        position: null,
        contract_type: null,
        send_reminder: null,
        email_types: null
      };
    },
    addModal() {
      this.isAdd = false;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = false;
      this.action = "Update";
      editObject.email_types = editObject?.email_types?.split(",");
      this.editObject = editObject;
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = true;
      this.action = "View";
      editObject.email_types = editObject?.email_types?.split(",");
      this.editObject = editObject;
      this.isModalActive = true;
    },
    editConfirm(d) {
      if (d) {
        this.fetchContactInformationData();
      }
      this.isModalActive = false;
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    deleteModal(editObject) {
      this.isAdd = true;
      this.action = "Delete";
      this.editObject = editObject;
      this.isModalActive = true;
    },
    prepareData(data) {
      for (const report in data) {
        const emailTypes = [];
        data[report]["actions"] = this.isEditAllowed(data.customer);
        data[report]["delete"] = this.isEditAllowed(data.customer);

        for (let i = 0; i < data[report]["contact_email_types"].length; i++) {
          emailTypes.push(data[report]["contact_email_types"][i]["name"]);
        }
        const emailTypesStr = emailTypes.join();
        data[report]["email_types"] = emailTypesStr;
      }
      this.data = data;
    },

    isEditAllowed(data) {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM)
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },

    fetchContactInformationData() {
      this.isLoading = true;
      this.ContactInformationService.getAll(this.$route.params.id).subscribe(
        response => {
          this.isLoading = false;
          this.prepareData(response);
        },
        e => {
          this.handleApiError(e);
        }
      );
    }
  }
};
</script>
